import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../config/siteConfig";
import "../css/privacy.scss";

function Cookies() {
  return (
    <main id="main-content" className="privacy-page">
      <header className="privacy-page__header"><p className="privacy-page__eyebrow">Information</p><h1>Cookie policy</h1><p>How {siteConfig.brandName} uses browser storage and similar technologies.</p></header>
      <div className="privacy-page__body">
        <section><h2>1. Essential storage</h2><p>We use local browser storage to remember basket and wishlist selections. This is necessary for shopping features and does not create advertising profiles.</p></section>
        <section><h2>2. Payment and security</h2><p>Our payment provider may use strictly necessary cookies on its hosted checkout to prevent fraud, maintain a secure session and complete payment.</p></section>
        <section><h2>3. Optional technologies</h2><p>We do not currently use advertising cookies or marketing pixels. If optional analytics are introduced, we will request consent where required.</p></section>
        <section><h2>4. Your controls</h2><p>You can clear site data using your browser settings. Doing so may remove saved basket and wishlist items.</p></section>
        <section><h2>5. Contact</h2><p>Questions can be sent to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>. See our <Link to="/privacy">privacy policy</Link> for more information.</p></section>
      </div>
    </main>
  );
}

export default Cookies;
